// import React from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Form,
//   Button,
  
// } from "react-bootstrap";

// import Agri1 from "../../assets/agri-1-30-11-25.png";
// import Agri2 from "../../assets/agri-2.png";
// import Agri3 from "../../assets/agri-3.png";
// import Agri4 from "../../assets/agri-4.png";
// import Agri5 from "../../assets/agri-5.png";
// import Agri6 from "../../assets/agri-6.png";
// import Agri7 from "../../assets/agri-7.png";
// import Agri8 from "../../assets/agri-8.png";
// import Agri9 from "../../assets/agri-9.png";


// export default function AMI() {
// //    const [open, setOpen] = useState(0);
  

//   return (
//     <>
//     <div className="bg-light py-5">
    
//            <section className="bg-light">
//                   <Container>
//                     <Row className="g-4 align-items-start">
//                       {/* LEFT CONTENT */}
//                       <Col lg={8}>
//                               <div>
//                                   <h1>New Agricultural Marketing Infrastructure scheme for Rural Godowns / Warehouse & Primary Processing units from Nabard</h1>

//                                   <p>In India where small and marginal farmers constitute major farming community, do not have the facility to retain the farm products with themselves till the market prices are favourable. It is very much essential to provide them with facilities for primary processing and scientific storage so that to avoid produce deterioration and enable them to meet their credit requirement. An establishment of primary processing units and rural godowns will enable small and marginal farmers to increase their holding capacity which will make them to sell their produce at remunerative prices and avoid distress sales. Accordingly, this New Agricultual Marketing Infrastructure scheme has been introduced by Govt. of India.</p>
//                                   <h2>Objectives</h2>
//                                   <p>The scheme's main goals are to build scientific storage capacity and related facilities in rural areas to meet farmers' needs for storing farm produce, processed farm produce, consumer goods, and agricultural inputs; to promote grading, standardisation, and quality control of agricultural produce to improve their marketability; and to avoid immediate distress sales.</p>

                                                               
//                               </div>
//                         </Col>
//                                 <Col lg={4}>
//                                              <div className="p-4 shadow rounded right-form">
//                                                <Form>
//                                                  <Form.Control className="mb-3" placeholder="Name" />
//                                                  <Form.Control className="mb-3" placeholder="Email" />
//                                                  <Form.Control className="mb-3" placeholder="Phone" />
//                                                  <Form.Control className="mb-3" placeholder="Subject" />
//                                                  <Button className="w-100">Get Started</Button>
//                                                </Form>
//                                              </div>
//                                </Col>
//             </Row>
//                       <Row className="g-4 align-items-start">
//                           <Col lg={12} xl={12}>
//                              <div>
//                                   <h2>FEATURES THAT ARE HEALTHY (Linkage to Marketing Reforms)</h2>
//                                   <p>State/UT agency non-storage infrastructure projects in those States/Union Territories that have amended their respective APMC Acts to include provisions for</p>

//                                   <ul>
//                                       <li>direct marketing;</li>
//                                       <li>contract farming</li>
//                                       <li>in the private and cooperative sectors, the establishment of a wholesale market for agricultural and associated products;</li>
//                                       <li>e-trading</li>
//                                       <li>a unified single trading licence that is valid throughout the state/UT</li>
//                                       <li>A single point market fee levy shall be eligible for assistance under the sub-scheme across the State/UT.</li>
//                                   </ul>

//                                   <h2>BENEFICIARIES WHO ARE ELIGIBLE:</h2>
//                                   <p>Storage infrastructure (capacity 50-5000 MTs) and non-storage infrastructure:</p>
//                                   <p>Individuals, Group of farmers / growers, FPOs/FPCs registered under respective companies Act/cooperatives societies Act/ societies registration Act (with minimum 50 number of farmer members); Partnership/ Proprietary firms, Companies, Corporations; Non Government Organizations (NGOs), Self Help Groups (SHGs); Cooperatives, Cooperative Marketing Federations; Autonomous Bodies of the Government, Local Bodies, Panchayats; State agencies including State Government Departments and autonomous organization / State owned corporations such as Agricultural Produce Market Committees & Marketing Boards, State Warehousing Corporations, State Civil Supplies Corporations etc.</p>
//                                   <p>Storage infrastructure (capacity 50 – 10,000 MTs):</p>
//                                   <p>State agencies include State Government Departments and autonomous organizations/stateowned enterprises such as Agricultural Produce Market Committees and Marketing Boards, State Warehousing Corporations, and State Civil Supplies Corporations, among others.</p>

//                                   <h2>ELIGIBLE MARKETING INFRASTRUCTURE:</h2>
//                                   <p>It is because one of the sub-goals scheme's is to ensure that farmers receive fair prices for their produce, actions involving storage or other marketing infrastructure up to primary processing will be covered. Cleaning, cutting, de-podding, de-cortication, dehusking, de-shelling, Grain cleaner, specific gravity separator, mini rice huller, drying equipments (solar/normal), bleaching, grading, sorting, packing/bag stitching, labelling, waxing, ripening, chilling, pasteurisation, homogenization, freezing, refrigeration, and other primary processing are eligible for AMI subsidies. Moreover, Mini Oil expeller for extraction of edible vegetable oil (as per FSSAI but without refining) from indigenous oilseeds (viz. Mustard seed, sesame seed, ground nut, linseed, mahua, safflower, nigerseed oil, coconut, almond and olive only) and Mini Dal mill for primary processing of pulses, including cleaning, grading, sorting, splitting, packaging and labelling to promote direct Only sheds and oil-expanders powered by up to 7.5 Horse Power are eligible for the subsidy for such projects (HP).</p>
//                                   <p>Annexure II contains a list of processing activities that are eligible and those that are not</p>
//                                   <p>Infrastructure for collection/assembly, drying, cleaning, grading, standardising, SPS (Sanitary and Phyto-sanitary) measures and quality certification, labelling, packaging, ripening chambers, waxing, value addition facilities (without affecting the product form), and so on.</p>
//                                   <p>Plant and equipment costs should be higher than 25% of the total financial outlay (TFO) of functional infrastructure projects (other than storage projects) when plant and machinery is to be put in civil structure. If it is less than 25%, the subsidy will be limited as described in Annexure IV. When the infrastructure is of the storage kind, the cost of storage is higher. When the infrastructure is of the storage type, the cost of the civil structure will be estimated according to the storage infrastructure's capacity and cost criteria</p>
//                                   <p>Platforms, sheds, drying facility (solar/normal), electronic weighing scale, assaying equipments, Computer IT equipments with internet connection, Godown, cold room, deep freezer/ Zero energy freezer, pack house, ripening chamber, information boards (electronic/non-elec) may be included in the infrastructure for developing/upgrading Rural Haats/RPMs as Grameen Agricultural Markets. Parking sheds, interior roads, garbage disposal arrangements, lighting arrangements, drinking water facilities, toilets, and other ancillary / supporting infrastructure are all permitted components.</p>
//                                   <p>However, as mentioned in Annexure III, the subsidy for auxiliary / supporting infrastructure in the project will be limited to 25% of the total permitted subsidy for the project. Annexure-V lists the cost norms for the pack house, cold room, ripening chamber, low-cost onion storage, and zeroenergy cold chamber.</p>
//                                   <p>Godowns, including stand-alone silos for food grain storage, as well as associated facilities such as loading, unloading, and bagging, are examples of storage infrastructure that are eligible. The cost of associated facilities such as a boundary wall, internal road, internal drainage system, weighing, grading, packing, quality testing & certification, fire fighting equipment, and other features essential to operate the project would be covered by storage infrastructure assistance.</p>
//                                   <p>All promoters across the country with a capacity of 50-5000 MT and State agencies with a capacity of 50-10000 MT in all States/UTs are eligible for subsidy under the sub-scheme.</p>
//                                   <p>Silos with a capacity of up to 15000 MT can be built for State Agency storage projects. The cost norms, subsidy percentage, and subsidy ceiling amount for state agencies for storage projects, as well as all other circumstances, shall stay the same. The Scheme does not include any funding for storage infrastructure renovations.</p>

//                                   <h2>INSTITUTIONAL LENDING:</h2>
//                                   <p>The sub-subsidy scheme's is tied to institutional credit and will only be accessible for projects financed by commercial, cooperative, regional rural banks, agricultural development finance companies (ADFCs), and state cooperative banks (SCBs), State Cooperative Agricultural and Rural Development Banks (SCARDBs), Scheduled Urban Cooperative Banks (SUCBs), Scheduled Primary Cooperative Banks (PCBs), North Eastern Development Financial Corporation (NEDFi), and other institutions eligible for refinancing by the National Bank for Agriculture and Rural Development (NABARD) or any other approved financial institution, such as State Financial Corporations (SFCs).</p>

//                                   <h2>PROMOTER'S CONTRIBUTION AND TERM LOAN:</h2>
//                                   <p>The promoter's contribution should be a minimum of 20% of the project cost. This should be ensured at the time of the project's real expense. If it is less than 20%, the actual TFO of the project will be limited to 5 times the promoter's contribution on project completion for the subsidy computation. The Financial Institution (FI) must grant a minimum term loan (including subsidy) of 50% of the project cost. The promoter's contribution might range from 20 to 50 percent of the TFO, while the term loan could range from 50 to 80 percent of the TFO.</p>

//                                   <h2>SUBSIDY PATTERN:</h2>
//                                   <p>The sub scheme envisages back-ended capital subsidy for investment in eligible storage, marketing infrastructure projects is as under:</p>

//                                   <h2>FOR STORAGE INFRASTRUCTURE PROJECTS:</h2>
//                                   <p>Capital cost of the project for the purpose of subsidy will be calculated on the project cost as appraised by financial institution or actual cost of eligible components as certified by a Chartered Accountant, whichever is lower subject to the subsidy ceiling per MT as well as overall ceiling given below:</p>

//                                   <img src={Agri1} alt="agri" className="img-fluid b-block mx-auto mb-3" />
                                  
//                                   <p>Cost norms for computing subsidy for silos will be same as for other storage infrastructure.</p>
//                                  <p>FOR INFRASTRUCTURE PROJECTS OTHER THAN STORAGE (NONSTORAGE) INFRASTRUCTURE INCLUDING FARMER-CONSUMERS MARKET AND DEVELOPMENT AND UPGRADATION OF RURAL HAATS/RPMs into GrAMs : Capital cost of the project for the purpose of subsidy will be calculated on the Project cost as appraised by financial institution or actual cost of eligible components as certified by a Chartered Accountant, whichever is lower.</p>

//                                   <img src={Agri2} alt="agri" className="img-fluid b-block mx-auto mb-3" />

//                                   <p>* Hilly area is a place at an altitude of more than 1,000 meters above mean sea level.</p>
//                                 <p>SC/ ST Cooperatives to be certified by the concerned officer of the State Government</p>
//                                 <p>or the projects of pulse splitting and oil crushing, the maximum subsidy for 25% category is Rs.12.50 lakh and 33.33% category is Rs.16.66 lakh only</p>

//                                   <h2>RELEASE OF FUNDS AND SUBSIDY:</h2>
//                                   <p>Advance subsidy: NABARD will release advance subsidy to the FI for keeping the same in a Subsidy Reserve Fund (SRF) account of the concerned borrowers, to be adjusted finally against loan amount. This amount of 50% eligible subsidy would be released by NABARD to the FI on submission of a project profile-cum-claim form (Annexure-VIII) complying to sub scheme guidelines.</p>
//                                   <p>al subsidy: Remaining 50% of the eligible subsidy amount will be released to the FI by NABARD after an inspection and recommendation by a Joint Inspection Committee (JIC) comprising of officers from NABARD (or its representative), FI and Directorate of Marketing & Inspection (DMI).</p>
                                  
//                                   <h2>TIME SCHEDULE FOR SUBMISSION OF APPLICATION AND COMPLETION OF PROJECT:</h2>
//                                   <p>FOR DISBURSEMENT OF ADVANCE SUBSIDY: FI will within 60 days of disbursal of the first instalment of loan, submit to RO, NABARD, through its controlling / nodal office, a brief project profile-cum-claim form for advance subsidy in the prescribed form given in Annexure-VIII along with the documents as per check list at Annexure-IX. A copy of the claim form along with all documents should also be submitted to the Regional Office / Sub-Office of DMI. FI will also inform the promoter about submission of the proposal to RO, NABARD & DMI. NABARD will submit a list of all the advance subsidy claims received at their end to the concerned DMI RO/SO on monthly basis. NABARD on regular basis will take up the matter of timely submission of advance subsidy claims with SLBC.</p>

                                   
//                                   <img src={Agri3} alt="agri" className="img-fluid b-block mx-auto mb-3" />
//                                     <img src={Agri4} alt="agri" className="img-fluid b-block mx-auto mb-3" />
//                                     <img src={Agri5} alt="agri" className="img-fluid b-block mx-auto mb-3" />
//                                     <img src={Agri6} alt="agri" className="img-fluid b-block mx-auto mb-3" />
//                                     <img src={Agri7} alt="agri" className="img-fluid b-block mx-auto mb-3" />
//                                     <img src={Agri8} alt="agri" className="img-fluid b-block mx-auto mb-3" />
//                                     <img src={Agri9} alt="agri" className="img-fluid b-block mx-auto mb-3" />

                                  






//                              </div>
//                               </Col>
//                           </Row>
//             </Container>
//         </section>
        
//     </div>
//     </>
//   );
// };


import React from "react";
import {
  Container,
  Row,
  Col
  
  
} from "react-bootstrap"; 


// import Agri9 from "../../assets/agri-9.png"; import Agri1 from "../../assets/agri-1-30-11-25.png";
// import Agri2 from "../../assets/agri-2.png";
// import Agri3 from "../../assets/agri-3.png";
// import Agri4 from "../../assets/agri-4.png";
// import Agri5 from "../../assets/agri-5.png";
// import Agri6 from "../../assets/agri-6.png";
// import Agri7 from "../../assets/agri-7.png";
// import Agri8 from "../../assets/agri-8.png";


export default function AMI() {
//    const [open, setOpen] = useState(0);
  

  return (
    <>
    <div className="bg-light py-5">
    
           <section className="bg-light">
                  <Container>
                    <Row className="g-4 align-items-start">
                      {/* LEFT CONTENT */}
                      <Col lg={12}>
                              <div>
                                  <h1>New Agricultural Marketing Infrastructure (AMI) sub scheme of Integrated Scheme for Agricultural Marketing (ISAM)</h1>
                                  <h2>For Rural Godown (Warehouses) & Primary Processing units (Seed Processing units, Cotton Ginning Mills, Rice Mills, Cashew nut processing units, etc.)</h2>

                  <br/>
                  <br/>
                  <h2>Main Objectives</h2>
                  <ul>
                  <li>Providing financial assistance (subsidies) for the construction or renovation of godowns, warehouses, and primary processing units.</li>
                  <li>Developing infrastructure to facilitate direct marketing from producers to consumers, processing units, or bulk buyers.</li>
                  <li>Encouraging primary processing activities like cleaning, grading, sorting, and packaging that improve marketability without changing the product's fundamental form.</li>
                  <li>Introducing modern technology and practices to preserve the quality and extend the life of agricultural produce.</li>
                     </ul>                                          
                              </div>
                        </Col>
                                {/* <Col lg={4}>
                                             <div className="p-4 shadow rounded right-form">
                                               <Form>
                                                 <Form.Control className="mb-3" placeholder="Name" />
                                                 <Form.Control className="mb-3" placeholder="Email" />
                                                 <Form.Control className="mb-3" placeholder="Phone" />
                                                 <Form.Control className="mb-3" placeholder="Subject" />
                                                 <Button className="w-100">Get Started</Button>
                                               </Form>
                                             </div>
                               </Col> */}
            </Row>                      
                      <Row className="g-4 align-items-start">
                          <Col lg={12} xl={12}>
                <div>
                  <h2>Eligible Beneficiaries:</h2>
                  <p>For creation of storage infrastructure and Primary Processing units.</p>
                  <p>Individuals, Group of farmers / growers, FPOs/FPCs registered under respective companies Act/cooperatives societies Act/ societies registration Act (with minimum 50 number of farmer members); Partnership/ Proprietary firms, Companies, Corporations; Non Government Organizations (NGOs), Self Help Groups (SHGs); Cooperatives, Cooperative Marketing Federations; Autonomous Bodies of the Government, Local Bodies, Panchayats; State agencies including State Government Departments and autonomous organization / State owned corporations such as Agricultural Produce Market Committees & Marketing Boards, State Warehousing Corporations, State Civil Supplies Corporations etc.</p>
                  
                  <h2>Eligible Financial Institutions / Banks :</h2>
                  <p>Commercial, Cooperative, Regional Rural Banks, Agricultural Development Finance Companies (ADFCs), State Cooperative Banks (SCBs), State Cooperative Agricultural and Rural Development Banks (SCARDBs), Scheduled Urban Cooperative Banks, Scheduled Primary Cooperative Banks (PCBs), North Eastern Development Financial Corporation (NEDFi), other institutions eligible for refinance by National Bank for Agriculture and Rural Page 9 of 61 Development (NABARD) or any other financial institution such as State Financial Corporations (SFCs) approved by DAC&FW.</p>

                  <h2>For creation of storage infrastructure (Rural Godown / Ware houses & Silos) :</h2>
                  <h3>Subsidy Pattern :</h3>

                  
                  <div className="table-responsive">
                    <table className="table table-bordered text-center">
                      <thead className="table-light">
                        <tr>
                          <th>Category</th>
                          <th>Rate of Subsidy (on capital cost)</th>
                          <th>More than 1000 MT and up to 5,000 (in Rs./MT)</th>
                          <th>Maximum ceiling (Rs. Lakhs)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="text-start">
                            For Registered FPOs, Panchayats, Women, Scheduled Caste (SC) / 
                            Scheduled Tribe (ST) entrepreneurs or their cooperatives / SHGs
                          </td>
                          <td>33.33%</td>
                          <td>2000.00</td>
                          <td>100.00</td>
                        </tr>
                        <tr>
                          <td className="text-start">
                            For all Other categories of beneficiaries
                          </td>
                          <td>25%</td>
                          <td>1500.00</td>
                          <td>75.00</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <h3 className="mt-4">Technical Specifications:</h3>

                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead className="table-light">
                        <tr>
                          <th style={{ width: "80px" }}>Sl. No.</th>
                          <th>Particular</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>1</td>
                          <td>
                            WDRA (Warehousing Development and Regulatory Authority) norms and registration certificate is mandatory.
                          </td>
                        </tr>

                        <tr>
                          <td>2</td>
                          <td>
                            Structure should be properly ventilated, have well fitted rolling shutters/steel doors,
                            air inlets/windows and ventilators and should be waterproof.
                          </td>
                        </tr>

                        <tr>
                          <td>3</td>
                          <td>
                            Minimum plinth height should be 2.5 feet. For smaller units (up to 500 MT), minimum 1.5 feet.
                          </td>
                        </tr>

                        <tr>
                          <td>4</td>
                          <td>
                            Protection from rodents with minimum plinth projection of 1.5 feet.
                          </td>
                        </tr>

                        <tr>
                          <td>5</td>
                          <td>
                            Protection from birds (ventilators with wire mesh).
                          </td>
                        </tr>

                        <tr>
                          <td>6</td>
                          <td>
                            Proper approach road, internal roads, drainage, fire safety, theft protection and easy loading/unloading.
                          </td>
                        </tr>

                        <tr>
                          <td>7</td>
                          <td>Only removable steps should be provided.</td>
                        </tr>

                        <tr>
                          <td>8</td>
                          <td>
                            New technologies like pre-engineered buildings are also eligible.
                          </td>
                        </tr>

                        <tr>
                          <td>9</td>
                          <td>
                            Compound wall with gate/fencing should be provided.
                          </td>
                        </tr>

                        <tr>
                          <td>10</td>
                          <td>
                            Godown must have valid insurance and fire-fighting equipment installed.
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <h3 className="mt-4">Important Conditions:</h3>

                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead className="table-light text-center">
                        <tr>
                          <th style={{ width: "80px" }}>S. No.</th>
                          <th>Particulars</th>
                          <th>Conditions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>1</td>
                          <td>Bank loan (Term Loan)</td>
                          <td>
                            Above 50% of total project cost (Project cost as per Bank appraisal / process note)
                          </td>
                        </tr>

                        <tr>
                          <td>2</td>
                          <td>Promoter contribution</td>
                          <td>
                            Above 20% of the total project cost (Project cost as per Bank appraisal / process note)
                          </td>
                        </tr>

                        <tr>
                          <td>3</td>
                          <td>Working capital</td>
                          <td>Working capital should not be included in the project cost</td>
                        </tr>

                        <tr>
                          <td>4</td>
                          <td>NABARD Application submission</td>
                          <td>
                            From the date of 1st disbursement of term loan, NABARD application must be submitted within 90 days
                          </td>
                        </tr>

                        <tr>
                          <td>5</td>
                          <td>Project start</td>
                          <td>
                            Expenditure made before sanction of term loan is not considered for subsidy calculation
                          </td>
                        </tr>

                        <tr>
                          <td>6</td>
                          <td>Project completion</td>
                          <td>
                            Project should be completed within 18 months from the date of first disbursement
                          </td>
                        </tr>

                        <tr>
                          <td>7</td>
                          <td>Lease Land</td>
                          <td>
Subsidy will also be made available for projects established on registered leased land, provided the tenure of such lease is more than 15 years from the date of sanction of term loan of project.                          </td>
                        </tr>

                         <tr>
                          <td>8</td>
                          <td>Subsidy Release</td>
                          <td>
                            NABARD releases advance subsidy to bank under Subsidy Reserve Fund (SRF) to be adjusted against loan                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <h3 className="mt-5">
                    For creation of Non-storage infrastructure (Cotton Mills, Seed Processing,
                    Rice Mills, Cashew Nut Processing units, etc.)
                  </h3>

                  <h4 className="mt-3">Subsidy Pattern:</h4>

                  <div className="table-responsive">
                    <table className="table table-bordered text-center">
                      <thead className="table-light">
                        <tr>
                          <th>Category</th>
                          <th>Rate of Subsidy (on capital cost)</th>
                          <th>Maximum ceiling (Rs. Lakhs)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="text-start">
                            For Registered FPOs, Panchayats, Women, Scheduled Caste (SC) /
                            Scheduled Tribe (ST) entrepreneurs or their cooperatives / SHGs
                          </td>
                          <td>33.33%</td>
                          <td>30.00</td>
                        </tr>

                        <tr>
                          <td className="text-start">
                            For all Other categories of beneficiaries
                          </td>
                          <td>25%</td>
                          <td>25.00</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <h4 className="mt-4">Important Conditions:</h4>

                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead className="table-light text-center">
                        <tr>
                          <th style={{ width: "80px" }}>S. No.</th>
                          <th>Particulars</th>
                          <th>Conditions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>1</td>
                          <td>Bank loan (Term Loan)</td>
                          <td>
                            Above 50% of total project cost (Project cost as per Bank appraisal / process note)
                          </td>
                        </tr>
                                      
                        <tr>
                          <td>2</td>
                          <td>Promoter contribution</td>
                          <td>
                            Above 20% of the total project cost (Project cost as per Bank appraisal / process note)
                          </td>
                        </tr>
                                      
                        <tr>
                          <td>3</td>
                          <td>Working capital</td>
                          <td>Working capital should not be included in the project cost</td>
                        </tr>
                                      
                        <tr>
                          <td>4</td>
                          <td>NABARD Application submission</td>
                          <td>
                            From the date of 1st disbursement of term loan, NABARD application must be submitted within 90 days
                          </td>
                        </tr>
                                      
                        <tr>
                          <td>5</td>
                          <td>Project start</td>
                          <td>
                            Expenditure made before sanction of term loan is not considered for subsidy calculation
                          </td>
                        </tr>
                                      
                        <tr>
                          <td>6</td>
                          <td>Project completion</td>
                          <td>
                            Project should be completed within 18 months from the date of first disbursement
                          </td>
                        </tr>
                                      
                        <tr>
                          <td>7</td>
                          <td>Lease Land</td>
                          <td>
Subsidy will also be made available for projects established on registered leased land, provided the tenure of such lease is more than 15 years from the date of sanction of term loan of project.                          </td>
                        </tr>

                         <tr>
                          <td>8</td>
                          <td>Subsidy Release</td>
                          <td>
                            NABARD releases advance subsidy to bank under Subsidy Reserve Fund (SRF) to be adjusted against loan                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                
                </div>
                              </Col>
                          </Row>
            </Container>
        </section>
        
    </div>
    </>    
  );
};



